export default {
  namespaced: true,
  state: {
    step1Data: {}
  }
};